import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const inbondTypesAdapter = getAdapter({ idFieldName: 'value' });

const inbondTypesSlice = createSlice({
    name: 'inbondTypes',
    initialState: inbondTypesAdapter.getInitialState(),
    reducers: {
        setInbondTypes: (state, { payload: { inbondTypes } }) => {
            inbondTypesAdapter.setAll(state, inbondTypes);
        },
    },
});

const selectors = inbondTypesAdapter.getSelectors(({ inbondTypes }) => inbondTypes);

export const getAllInbondTypes = (state) => selectors.selectAll(state);

export const {
    setInbondTypes,
} = inbondTypesSlice.actions;

export default inbondTypesSlice.reducer;
